import { get, post } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse, ThreadItem } from "./types";
// 搜索相关API
export const searchApi = {
  /**
   * 搜索帖子
   * @param params - 搜索参数
   * @returns Promise<ApiResponse<ThreadItem[]>>
   */
  searchThreads: (params: SearchParams): Promise<ApiResponse<ThreadItem[]>> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.SEARCH,
      API_CONFIG.ACTIONS.THREAD,
      params
    );
    return get<ApiResponse<ThreadItem[]>>(url);
  },
  /**
   * 搜索用户
   * @param params - 搜索参数
   * @returns Promise<ApiResponse<UserInfo[]>>
   */
  searchUsers: (params: SearchParams): Promise<ApiResponse<UserInfo[]>> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.SEARCH,
      API_CONFIG.ACTIONS.USER,
      params
    );
    return get<ApiResponse<UserInfo[]>>(url);
  },

  /** /
   * 获取热门关键词
   * @returns Promise<ApiResponse<string[]>>
   */
  getHotKeywords: (game_id: string, target_language: string): Promise<ApiResponse<string[]>> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.SEARCH,
      API_CONFIG.ACTIONS.HOT_KEYWORDS,
      { game_id, target_language }
    );
    return get<ApiResponse<string[]>>(url);
  },
};
